
import React from 'react';
import { FileText } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';

export const AuditLogsTab: React.FC = () => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between space-x-2">
        <div className="space-y-0.5">
          <div className="flex items-center">
            <FileText className="h-5 w-5 mr-2 text-primary" />
            <h3 className="font-medium text-lg">Audit Logs</h3>
          </div>
          <p className="text-muted-foreground text-sm">
            View and manage system audit logs
          </p>
        </div>
      </div>
      
      <Separator />
      
      <div className="border rounded-md p-6 bg-muted/50">
        <div className="flex items-center justify-center h-24">
          <div className="text-center">
            <p className="text-muted-foreground mb-2">Audit logging system not configured</p>
            <Button variant="outline" disabled className="gap-1">
              <FileText className="h-4 w-4" />
              Setup Audit Logging
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
